import { Typography } from '@mui/material'
import * as S from './PendingRequestsAlert.styles'

interface PendingRequestsAlertProps {
  setPostponePendingRequests: React.Dispatch<React.SetStateAction<boolean>>
}

const PendingRequestsAlert: React.FC<PendingRequestsAlertProps> = ({ setPostponePendingRequests }) => (
  <S.Container>
    <Typography variant='h6'>
      Há pendências anteriores, no qual foram adiadas, caso queira resolver agora, clique no botão abaixo.
    </Typography>
    <S.CustomButton
      title='Resolver pendências adiadas'
      bgColor='confirm'
      hoverColor='confirmHover'
      letterColor='white'
      onClick={() => setPostponePendingRequests(false)}
      data-testid='resolve-pending-requests-button-test-id'
    />
  </S.Container>
)

export default PendingRequestsAlert
